module.exports = __webpack_public_path__ + "img/favicon-logo-inergi.fb774a72.png";